var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 36,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m15.905 17.939-5.184 8.977-2.234 3.864L0 25.878l4.595-7.957L0 9.963l8.49-4.891 2.132 3.682 5.28 9.147q0 .018.003.038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M43.114 17.923a17.917 17.917 0 0 1-17.92 17.919H11.5l1.405-2.425 3.702-6.415h8.587a9.083 9.083 0 0 0 8.526-12.59 9.08 9.08 0 0 0-8.526-5.57h-8.686l-3.603-6.24L11.404 0h13.79a17.92 17.92 0 0 1 17.92 17.923"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    d: "M57.244 10.495h5.955c4.986 0 8.14 2.779 8.14 7.212s-3.132 7.127-8.14 7.127h-5.955zm5.955 11.68c3.199 0 5.207-1.743 5.207-4.504s-2.03-4.521-5.207-4.521H60v9.025h3.2zm11.782-11.68h13.614v2.655H77.742v2.955h9.662v2.655h-9.662v3.375l10.853.022v2.655H74.98zm18.024 0h13.614v2.655H95.766v2.955h9.663v2.655h-9.663v3.375l10.853.022v2.655H93.005zm16.573 14.68h9.774v2.654h-9.774zm16.919-7.601-5.225-7.079h3.637l3.331 4.522 3.155-4.522h3.641l-5.119 6.796 5.561 7.521h-3.641l-3.685-5.008-3.486 5.008h-3.637z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 15.905,
    y1: 17.921,
    y2: 17.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f85d31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.404,
    x2: 43.114,
    y1: 17.921,
    y2: 17.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0eb4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b75c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.6f3beca86f70621659dfc31acbebffb5.svg";
export { ForwardRef as ReactComponent };